import { styled } from '@mui/material';
import { ReactNode } from 'react';

import { StickyHeader } from './components/StickyHeader';
import { Box } from '../Box';

export type SectionProps = {
  children: ReactNode;
  header?: ReactNode;
  className?: string;
};

const StyledSection = styled(Box)(({ theme }) => ({
  border: '1px solid var(--stroke-stroke-secondary-color)',
  backgroundColor: 'var(--background-background-color)',
  borderRadius: theme.spacing(2),
  flex: 1,
  overflow: 'auto',
  display: 'flex',
  flexDirection: 'column',
}));

const SectionContent = styled(Box)<{ noTopPadding?: boolean }>(
  ({ theme, noTopPadding }) => ({
    overflow: 'auto',
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(4),
    paddingTop: noTopPadding ? 0 : undefined,
    gap: theme.spacing(2),
    flex: 1,
  })
);

export const Section = ({ children, header, className }: SectionProps) => {
  return (
    <StyledSection className={className}>
      {header}
      <SectionContent noTopPadding={!!header}>{children}</SectionContent>
    </StyledSection>
  );
};

Section.StickyHeader = StickyHeader;
